export default "__VITE_ASSET__ff30b1b0__"